import { render, staticRenderFns } from "./ActInfo.vue?vue&type=template&id=30e472a0&scoped=true"
import script from "./ActInfo.vue?vue&type=script&lang=js"
export * from "./ActInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e472a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e472a0')) {
      api.createRecord('30e472a0', component.options)
    } else {
      api.reload('30e472a0', component.options)
    }
    module.hot.accept("./ActInfo.vue?vue&type=template&id=30e472a0&scoped=true", function () {
      api.rerender('30e472a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign-challenge/components/ActInfo.vue"
export default component.exports